/**
 * 同一パターンで起動済みのメンバーを候補から除外する条件。
 *
 * 400 件 × 複数回に分けて起動する運用で、同じ人を二重に起動してしまう事故を防ぐための
 * 絞り込み。`Aborted`（中断）はサーバー側の突合対象に含まれないため、中断された人は
 * どの条件でも候補に残る。
 */
export const STARTED_TARGETS_FILTER_OPTIONS = ['NONE', 'IN_PROGRESS', 'IN_PROGRESS_OR_COMPLETED'] as const;
export type StartedTargetsFilterValue = (typeof STARTED_TARGETS_FILTER_OPTIONS)[number];

/**
 * 既定値。誤って二重起動するのを防ぐことが目的なので、進行中を隠した状態で画面を開く。
 * 完了済みは次ラウンドの再送対象になり得るため既定では隠さない。
 */
export const DEFAULT_STARTED_TARGETS_FILTER: StartedTargetsFilterValue = 'IN_PROGRESS';